// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const eventTypeSchema = z.object({
  "id": z.string(),
  "description": z.string(),
  "severity": z.enum(["info", "warning", "critical"]),
  "category": z.enum(["notification", "alert"]),
  "default_channels": z.array(z.enum(["inapp", "email", "webhook", "slack", "pagerduty", "sms"]))
}).strict();

export const eventTypesResponseSchema = z.object({
  "data": z.array(eventTypeSchema)
}).strict();

export const subscriptionSchema = z.object({
  "id": z.string().uuid(),
  "event_type_pattern": z.string(),
  "recipient": z.object({
    "kind": z.enum(["admin", "user", "webhook", "email_external", "role"]),
    "admin_id": z.string().uuid().optional(),
    "user_id": z.string().uuid().optional(),
    "webhook_id": z.string().uuid().optional(),
    "email": z.string().optional(),
    "role": z.string().optional()
  }).strict(),
  "channels": z.array(z.enum(["inapp", "email", "webhook", "slack", "pagerduty", "sms"])),
  "severity_floor": z.enum(["", "info", "warning", "critical"]),
  "enabled": z.boolean(),
  "created_at": z.string().datetime({ offset: true })
}).strict();

export const subscriptionsResponseSchema = z.object({
  "data": z.array(subscriptionSchema).max(500)
}).strict();
